import { render, staticRenderFns } from "./FilterNftAssetCollectionMobile.vue?vue&type=template&id=2c90c5af&scoped=true"
import script from "./FilterNftAssetCollectionMobile.vue?vue&type=script&lang=ts"
export * from "./FilterNftAssetCollectionMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90c5af",
  null
  
)

export default component.exports